import React, { useEffect, useState } from 'react';
import styles from './Enquiries.module.css';

const EnquiriesHeader = ({ onNewEnquiry, walkthrough }) => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  useEffect(() => {
    if (!isVideoOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsVideoOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isVideoOpen]);

  const hasWalkthrough = Boolean(walkthrough?.embedUrl);

  return (
    <div className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.headerText}>
          <h1 className={styles.headerTitle}>Enquiries</h1>
          <p className={styles.headerSubtitle}>
            Manage incoming customer enquiries and convert them to projects
          </p>

          {hasWalkthrough && (
            <div className={styles.walkthroughRow}>
              <button
                type="button"
                className={styles.walkthroughButton}
                onClick={() => setIsVideoOpen(true)}
              >
                <svg
                  className={styles.walkthroughIcon}
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M8 5.14v13.72a1 1 0 0 0 1.55.83l9.2-6.86a1 1 0 0 0 0-1.66l-9.2-6.86A1 1 0 0 0 8 5.14z" />
                </svg>
                Watch walkthrough
              </button>
              {walkthrough?.durationLabel && (
                <span className={styles.walkthroughDuration}>
                  {walkthrough.durationLabel}
                </span>
              )}
            </div>
          )}
        </div>

        <button
          onClick={onNewEnquiry}
          className={styles.newEnquiryButton}
        >
          <svg 
            className={styles.buttonIcon} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 6v6m0 0v6m0-6h6m-6 0H6" 
            />
          </svg>
          New Enquiry
        </button>
      </div>

      {isVideoOpen && (
        <div
          className={styles.videoModalOverlay}
          onClick={() => setIsVideoOpen(false)}
        >
          <div
            className={styles.videoModal}
            onClick={(event) => event.stopPropagation()}
          >
            <div className={styles.videoModalHeader}>
              <div className={styles.videoModalTitle}>
                {walkthrough?.title || 'Enquiries walkthrough'}
              </div>
              <button
                type="button"
                className={styles.videoModalClose}
                onClick={() => setIsVideoOpen(false)}
                aria-label="Close video"
              >
                ✕
              </button>
            </div>

            <div className={styles.videoFrame}>
              <iframe
                src={walkthrough.embedUrl}
                title={walkthrough?.title || 'Enquiries walkthrough'}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EnquiriesHeader;
